import { ErrorMessage } from "@/app/error"
import { useScroller } from "@/app/grid/scroller/scroller-provider"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { Suspense, useEffect } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { NftFiltersMoleculeReatom } from "../../filters/store.reatom"
import { useUrlPersistence } from "../../filters/use-url-persistence"
import { NftSortMoleculeReatom } from "../../sort/store.reatom"
import { GridSkeleton, GridView } from "./grid/grid"
import { TableSkeleton, TableView } from "./table/table"
import { ViewType } from "./view-selector/types"

export const NftSearchResult = reatomComponent(
  ({ viewType }: { viewType: ViewType }) => {
    return (
      <ErrorBoundary fallback={<ErrorMessage />}>
        <Suspense
          fallback={
            viewType === ViewType.GRID ? <GridSkeleton /> : <TableSkeleton />
          }
        >
          <SearchResultView viewType={viewType} />
        </Suspense>
      </ErrorBoundary>
    )
  },
  "NftSearchResult",
)

const SearchResultView = reatomComponent<{ viewType: ViewType }>(
  ({ viewType }) => {
    useUrlPersistence()
    useScrollTop(viewType)

    return viewType === ViewType.TABLE ? <TableView /> : <GridView />
  },
  "SearchResultView",
)

export const useScrollTop = (viewType: ViewType) => {
  const scroller = useScroller()

  const { allFilters } = useMolecule(NftFiltersMoleculeReatom)
  const { sortAtom } = useMolecule(NftSortMoleculeReatom)
  const sort = sortAtom()
  const appliedFilters = allFilters()

  useEffect(() => {
    if (appliedFilters || sort || viewType === ViewType.TABLE) {
      const scrollParent = scroller.current ?? window

      scrollParent.scrollTo({ top: 0 })
    }
  }, [sort, appliedFilters, scroller, viewType])
}
